import styled from 'styled-components';

const Wrapper = styled.div`
    height: 60px;
    left: 0px;
    max-width: 100%;
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 10;
`

export default Wrapper;



// WEBPACK FOOTER //
// ./src/components/Nav/Wrapper.js